<template>
  <div class="exrecord">
    <div class="nav-btns">
      <el-input 
        v-model="thingText"
        placeholder="请输入物品名称"
        style="width: 200px;"
      >
      </el-input>
      <el-date-picker
        v-model="selectTime"
        type="daterange"
        range-separator="-"
        value-format='yyyy-MM-dd HH:mm:ss'
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button
        type="primary"
        size="small"
        @click="query"
      >
        提交
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      width="100%"
      max-height="370"
      border
      style="width: 100%; margin-bottom: 15px;">
      <el-table-column
        v-for="(item, index) in tableConfig"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="item.prop === 'exchangeTime'">{{ scope.row[item.prop] | filterTime(scope.row[item.prop]) }}</span>
          <span v-else-if="item.prop === 'bindStatus'">
            <el-button size="small" type="primary" @click="openAddress(scope.row)" v-if="!isNaN(Number(scope.row[item.prop])) && Number(scope.row[item.prop]) !== 1">
              {{ scope.row[item.prop] | filterRemark(scope.row[item.prop]) }}
            </el-button>
          </span>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.length !== 0"
      @current-change="handleCurrentChange"
      background
      :current-page="currentPage"
      layout="total, prev, pager, next"
      :total="totalPage"
    >
    </el-pagination>
    <div class="mask" v-if="showPop">
      <div class="address-pop" v-if="showAddress">
        <div class="address-title">
          <div class="address-title-msg">兑换成功，请填写邮寄地址</div>
          <div class="address-title-close" @click="closeAddress">X</div>
        </div>
        <div class="address-common">
          <div class="address-input-box">
            <label for="">联系人：</label>
            <input type="text" v-model="addressInfo.contacts" class="address-input-user">
          </div>
          <div class="address-input-box">
            <label for="">联系电话：</label>
            <input type="text" v-model="addressInfo.phone" class="address-input-user" maxlength="11">
          </div>
          <div class="address-input-box">
            <label for="">详细地址：</label>
            <textarea type="text" v-model="addressInfo.address" class="address-input-textarea"></textarea>
          </div>
        </div>
        <div class="address-btn" @click="bindAddress">
          提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExchangeHistory, bindUserAddress } from '@/api/points.js'
export default {
  name: 'exchangeRecord',
  data() {
    return {
      thingText: '',
      selectTime: '',
      tableData: [],
      tableConfig: [
        {
          prop: 'exchangeTime',
          label: '日期',
          width: 80
        },
        {
          prop: 'exchangePoint',
          label: '积分',
          width: 80
        },
        {
          prop: 'productName',
          label: '兑换商品'
        },
        {
          prop: 'bindStatus',
          label: '备注'
        }
      ],
      totalPage: 0,
      currentPage: 1,
      loading: false,
      showPop: false,
      showAddress: false,
      addressInfo: {
        bindEvidence: '',
        transactionId: '',
        contacts: '',
        phone: '',
        address: '',
      }
    };
  },
  filters: {
    filterTime(time) {
      return new Date(time * 1000).toLocaleDateString()
    },
    filterRemark(status) {
      return Number(status) === 0 ? '填写地址' : ''
    }
  },
  mounted() {
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.query()
    },
    query() {
      this.loading = true
      this.tableData = []
      this.totalPage = 0
      if (!this.selectTime && this.thingText === '') {
        this.$message({
          type: 'error',
          message: '请输入搜索条件！'
        })
        this.loading = false
        return false
      }
      getExchangeHistory({
        pageNum: this.currentPage,
        pageSize: 10,
        productName: this.thingText,
        startTime: this.selectTime ? new Date(this.selectTime[0]).getTime() / 1000 : '',
        endTime:  this.selectTime ? new Date(this.selectTime[1]).getTime() / 1000 : '',
      }).then((res) => {
        this.loading = false
        if (res && res.code === 0) {
          this.tableData = res.data.content
          this.totalPage = res.data.totalCount
        }
      })
    },
    openAddress(item) {
      this.showPop = true
      this.showAddress = true
      this.addressInfo.bindEvidence = item.bindEvidence
      this.addressInfo.transactionId = item.transactionId
    },
    closeAddress() {
      this.showPop = false
      this.showAddress = false
      this.addressInfo.address = ''
      this.addressInfo.contacts = ''
      this.addressInfo.phone = ''
      this.addressInfo.bindEvidence = ''
      this.addressInfo.transactionId = ''
    },
    bindAddress() {
      if (!/^1[0-9]{10}/.test(this.addressInfo.phone)) {
        this.$message({
          type: 'error',
          message: '请正确填写手机号码'
        })
        return false
      }
      if (!/^[\u4e00-\u9fa5]+$/.test(this.addressInfo.contacts)) {
        this.$message({
          type: 'error',
          message: '请正确填写姓名'
        })
        return false
      }
      if (this.addressInfo.address === '') {
        this.$message({
          type: 'error',
          message: '请填写详细地址'
        })
        return false
      }
      bindUserAddress(this.addressInfo).then((res) => {
        if (res && res.code === 0) {
          this.showPop = false
          this.showAddress = false
          this.addressInfo.address = ''
          this.addressInfo.contacts = ''
          this.addressInfo.phone = ''
          this.addressInfo.bindEvidence = ''
          this.addressInfo.transactionId = ''
          this.$message({
            type: 'success',
            message: '填写成功'
          })
          this.query()
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.msg
        })
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.exrecord {
  width: 95%;
  margin: 0 auto;
  margin-top: 38px;
  box-shadow: 0px 0px 7px #888888;
  box-sizing: border-box;
  padding: 15px 10px 15px 10px;
  .nav-btns{
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/ .el-input {
      margin-right: 15px;
    }
    /deep/ .el-input__inner {
      margin-right: 15px;
      line-height: 32px;
      height: 32px;
    }
    /deep/ .el-range-editor.el-input__inner {
      padding: 0 10px;
    }
  }
  /deep/ .el-table th.gutter {
    display: none;
    width: 0;
  }
  /deep/ .el-table colgroup col[name='gutter']{
    display: none;
    width: 0;
  }
  /deep/ .el-table__body {
    width: 100% !important;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .address-pop {
      width: 435px;
      height: 310px;
      position: absolute;
      left: 50%;
      top: 25%;
      transform: translateX(-50%);
      background-color: #fff;
      animation: showDialog 0.5s;
      animation-timing-function: cubic-bezier(0.6,0,0.4,1);
      .address-title {
        display: flex;
        box-sizing: border-box;
        justify-content: flex-start;
        align-items: center;
        height: 50px;
        width: 100%;
        background: #ec6c04;
        padding-right: 13px;
        .address-title-msg {
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          flex: 1;
        }
        .address-title-close {
          font-size: 24px;
          font-weight: bold;
          color: #fff;
          cursor: pointer;
          width: 22px;
          height: 22px;
        }
      }
      .address-common {
        overflow: hidden;
        width: 280px;
        margin: 0 auto;
        margin-top: 5px;
        .address-input-box {
          display: flex;
          margin-top: 12px;
          align-items: flex-start;
          justify-content: flex-start;
          label {
            width: 90px;
            text-align: left;
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            color: #6a6a6a;
          }
          .address-input-user {
            height: 30px;
            line-height: 30px;
            // margin-left: 15px;
            border: 1px solid #ececec;
            box-sizing: border-box;
            width: 190px;
            padding: 5px 0;
            padding-left: 15px;
            font-size: 18px;
            outline: none;
            font-family: "微软雅黑";
          }
          .address-input-textarea {
            border: 1px solid #ececec;
            padding: 5px 0;
            padding-left: 15px;
            box-sizing: border-box;
            width: 190px;
            height: 65px;
            font-size: 18px;
            outline: none;
            font-family: "微软雅黑";
            resize: none;
          }
        }
      }
      .address-btn {
        width: 235px;
        height: 50px;
        background: #ec6c04;
        color: #fff;
        font-size: 22px;
        font-weight: bold;
        margin: 0 auto;
        margin-top: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }
}
@keyframes showDialog {
  0% {
    opacity: 0;
    left: 50%;
    transform: scale3d(0, 0, 0), translateX(-50%);
  }
  100% {
    opacity: 1;
    left: 50%;
    transform: scale3d(1, 1, 1), translateX(-50%);
  }
}
</style>